import React from 'react';

const SeoRoutingContext = React.createContext();

export const SeoRoutingProvider = SeoRoutingContext.Provider;
export const SeoRoutingConsumer = SeoRoutingContext.Consumer;

export default SeoRoutingContext;
